module.exports = __webpack_public_path__ + "static/event12-e2d86c7a16fe88187c4db69996183078.jpeg";